import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { DatePipe } from '@angular/common';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { CKEditorComponent } from '@ckeditor/ckeditor5-angular';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { RemmiConfirmService } from '@common/remmi-confirm/remmi-confirm.service';
import { automationImages } from '@images/automation-images';
import { ApiService } from '@services/api/api.service';
import { ContractApiService } from '@services/api/contract.service';
import { EntityManagerService } from '@services/api/entity-manager.service';
import { SharedService } from '@services/api/shared.service';
import { TaskService } from '@services/api/task.service';
import { WorkflowService } from '@services/api/workflow.service';
import { LeadManagementService } from '@services/lm-service/lead-management.service';
import moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { InputSwitchOnChangeEvent } from 'primeng/inputswitch';
import { Subject } from 'rxjs';
import * as copy from 'src/assets/js/copy.js';
import { v4 as uuidv4 } from 'uuid';
import { LeftFlowComponent } from '../left-flow/left-flow.component';
import { commonImages } from '@images/common-images';

// export class UploadAdapter {
//   private loader;
//   constructor(
//     loader,
//     private api: ApiService
//   ) {
//     this.loader = loader;
//   }
// }

@Component({
  selector: 'app-flow-main',
  templateUrl: './flow-main.component.html',
  styleUrls: ['./flow-main.component.scss'],
})
export class FlowMainComponent implements OnInit, OnDestroy {
  @ViewChild('editorRef', { static: false }) editorRef!: CKEditorComponent;
  @ViewChild(LeftFlowComponent) leftFlowComponent: LeftFlowComponent;
  toggleProcessPaneObservable: Subject<Boolean> = new Subject<Boolean>();
  common_images = commonImages;
  images = automationImages;
  all_module_fields: any[] = [];
  zoom_: number = 1;
  isRightBarView: boolean = false;
  toggleProcessPane: Boolean = false;
  module_array_extended: any[] = [];
  public Editor = ClassicEditor;
  flowStackCall: any[] = [];
  tigger_title: string = '';
  parent_id: number = null;
  con_id: any = null;
  card_Id: any;
  flow: any = null;
  flow_data: any = [
    {
      notification: {
        notification_to: [],
        notify_user: null,
        user: null,
        notify_from: null,
        sender: null,
        subject: '',
        message: '',
      },
    },
  ];
  showIcon: boolean = false;
  icon_list: any[] = [];
  isIcon: any = 'Icon Selection';
  display_icon: any = 'pi pi-briefcase';
  isSvg: boolean = false;
  entityField: any = [];
  notification: any = {
    notification_to: [],
    notify_user: null,
    user: null,
    subject: '',
    message: '',
  };
  selected_condition: any = null;

  condition_input: any[] = [
    {
      parent: -1,
      id: uuidv4(),
      iscondition: true,
      children: [],
      condition_id: 1,
    },
  ];
  tempConditionInput = JSON.stringify(this.condition_input);
  AssignInputFieldValues() {
    this.flow_data.inputfield = this.condition_input;
  }
  getIconClass(icon: string | undefined | null): string | string[] {
    if (!icon) {
      return 'pi pi-plus invisible';
    }
    if (icon.includes('pi')) {
      return ['pi', icon];
    }
    return icon;
  }
  flow_actions: any[] = [
    {
      label: 'Add Same Level',
      icon: 'pi pi-fw pi-plus',
      command: () => {
        this.AddNewItemSameLevel(this.selected_condition, true);
        this.AssignInputFieldValues();
      },
    },
    {
      label: 'Add Sub Level',
      icon: 'pi pi-fw pi-download',
      command: () => {
        this.AddNewItemSubLevel(this.selected_condition, 'condition');
        this.AssignInputFieldValues();
      },
    },
    {
      label: 'Add Clause',
      icon: 'pi pi-fw pi-download',
      command: () => {
        if (this.selected_condition?.iscondition) {
          this.AddNewItemSubLevel(this.selected_condition, 'entry');
          this.AssignInputFieldValues();
        } else {
          this.addOrRemoveItemInParentNode(this.condition_input, this.selected_condition?.id, null, 'entry');
          this.AssignInputFieldValues();
        }
      },
    },
    {
      label: 'Add Cross Module Clause',
      icon: 'pi pi-fw pi-download',
      command: () => {
        if (this.selected_condition?.iscondition) {
          this.AddNewItemSubLevel(this.selected_condition, 'entry', true);
          this.AssignInputFieldValues();
        } else {
          this.addOrRemoveItemInParentNode(this.condition_input, this.selected_condition?.id, null, 'entry', true);
          this.AssignInputFieldValues();
        }
      },
    },
    {
      label: 'Delete',
      icon: 'pi pi-fw pi-refresh',
      command: () => {
        this.AddNewItemSameLevel(this.selected_condition, false);
        this.AssignInputFieldValues();
      },
    },
  ];

  constructor(
    public _workflowService: WorkflowService,
    private toast: ToastrService,
    private api: ApiService,
    private sanitizer: DomSanitizer,
    private task: TaskService,
    private router: Router,
    public lmService: LeadManagementService,
    private datePipe: DatePipe,
    private _contractService: ContractApiService,
    private _sharedService: SharedService,
    private _entityManagerService: EntityManagerService,
    private remmiConfirm: RemmiConfirmService
  ) {
    _workflowService.isWorkflowOpened = true;
    this.icon_list = _workflowService.RemixIcons;
    this.flow = _workflowService.workFlow;
    this.module_array_extended = this._workflowService?.module_array?.map(value => ({ ...value, module_value: value?.module_value?.toLowerCase() }));
  }

  ngOnDestroy(): void {
    this._workflowService.isWorkflowOpened = false;
  }

  AddNewItemSubLevel(data: any, addByCategory = 'entry', is_cross = false) {
    // if the node has children, then add a new item to the children array
    // if not, then create a new children array and add a new item to it
    if (data?.children?.length > 0) {
      if (addByCategory === 'entry') {
        data.children.push({ parent: data?.id, id: uuidv4(), iscondition: false, category_id: 'C1', is_cross: is_cross });
      } else {
        data.children.push({ parent: data?.id, id: uuidv4(), iscondition: true, condition_id: 1, is_cross: is_cross });
      }
    } else {
      if (addByCategory === 'entry') {
        data['children'] = [{ parent: data?.id, id: uuidv4(), iscondition: false, category_id: 'C1', is_cross: is_cross }];
      } else {
        data['children'] = [{ parent: data?.id, id: uuidv4(), iscondition: true, condition_id: 1, is_cross: is_cross }];
      }
    }
  }

  addOrRemoveItemInParentNode = (array, selector, isValueExists = null, addByCategory = 'condition', is_cross = false) => {
    // loop through the array and check if the id of the node matches the selector
    // if it does then check if the node has children
    // if it does then check if isValueExists is not null
    // if it is not null then remove the item from the children array
    // if it is null then add a new item to the children array
    // if the node does not have children then check if isValueExists is not null
    // if it is not null then remove the item from the array
    // if it is null then add a new item to the array
    for (const node of array) {
      if (node?.id === selector) {
        if (node?.children?.length > 0) {
          if (isValueExists !== null) {
            let index = node?.children?.findIndex(x => x.id === isValueExists);
            node?.children.splice(index, 1);
          } else {
            if (addByCategory === 'entry') {
              node.children.push({ parent: node?.id, id: uuidv4(), iscondition: false, category_id: 'C1', is_cross: is_cross });
            } else {
              node.children.push({ parent: node?.id, id: uuidv4(), iscondition: true, is_cross: is_cross });
            }
          }
        } else {
          if (isValueExists !== null) {
            let index = array?.findIndex(x => x.id === isValueExists);
            array?.splice(index, 1);
          } else {
            if (addByCategory === 'entry') {
              node['children'] = [{ parent: node?.id, id: uuidv4(), iscondition: false, category_id: 'C1', is_cross: is_cross }];
            } else {
              node['children'] = [{ parent: node?.parent == -1 ? uuidv4() : node?.parent, id: uuidv4(), iscondition: true, is_cross: is_cross }];
            }
          }
        }
      } else if (node?.children && node?.children?.length > 0) {
        this.addOrRemoveItemInParentNode(node?.children, selector, isValueExists, addByCategory, is_cross == true ? true : false);
      }
    }
  };

  ngOnInit(): void {
    // check if the current route is not /setting/workflow/flow
    // if yes then show the right bar and hide the left menu
    // else hide the right bar and show the left menu
    if (this.router.url != '/setting/workflow/flow') {
      this.isRightBarView = true;
      this.lmService.is_menu_hide = false;
    } else {
      this.lmService.is_menu_hide = true;
      this.lmService.selected_workflow = null;
    }
    // initialize the workflow
    this.init();
    // get the entity field
    this.getEntityField();
  }

  init = () => {
    // Get user roles, office contacts, users, office team and email sender list
    // Then initialize the task types and statuses
    this.GetUserRoles();
    this.getUsers();
    this.getOfficeTeam();
    this.GetOfficeContacts();
    this.getEmailSenderList();
    this.onIntItTask();
  };

  onIntItTask = () => {
    // Get task types and statuses for the workflow
    this.task.getTypes({ office_id: this.api.getOfficeId() }).subscribe(response => {
      this.jobTypes = response.data;
    });
    this.task.getStatuses({ office_id: this.api.getOfficeId() }).subscribe(response => {
      this.taskStatuses = response.data;
    });

    // Get the email template for the workflow
    // this.getEmailTemplate();
  };

  GetUserRoles() {
    // Get all roles from the office
    // This is used to populate the list of roles that can be selected for a task
    try {
      this._workflowService.GetAllUserRoles().subscribe({
        next: response => {
          if (response?.status) {
            let record: any[] = response.data
              .sort(function (a, b) {
                return a?.name.localeCompare(b?.name);
              })
              .map(result => ({ ...result, category: 'Roles', full_name: result?.name }));
            this.UserRoles = record?.filter(result => result?.id !== 12 && result?.id !== 1);
            this.NotificationUserRoles = record;
          }
        },
        error: _ => {
          this.UserRoles = this.NotificationUserRoles = [];
        },
      });
    } catch (error) {
      console.log('Error => ', error?.message);
    }
  }

  GetOfficeContacts() {
    // Get all contacts from the office
    // This is used to populate the list of contacts that can be assigned to a task
    this._workflowService.GetAllOfficeContacts().subscribe({
      next: response => {
        if (response?.status) {
          let record: any[] = response.data
            .sort(function (a, b) {
              return a?.full_name.localeCompare(b?.full_name);
            })
            .map(result => ({ ...result, category: 'Contacts' }));
          this.OfficeContacts = record;
        }
      },
      error: _ => {
        this.OfficeContacts = [];
      },
    });
  }
  getOfficeTeam() {
    // Get all teams from the office
    // This is used to populate the list of teams that can be assigned to a task
    this._workflowService.GetOfficeTeams().subscribe({
      next: response => {
        if (response?.status) {
          let record: any[] = response.data.sort(function (a, b) {
            return a?.name.localeCompare(b?.name);
          });
          this.OfficeTeams = record;
        }
      },
      error: _ => {
        this.OfficeTeams = [];
      },
    });
  }

  getUsers() {
    // Get all users from the API
    // This is used to populate the list of users that can be assigned to a task
    if (this.api.getOfficeId() && this.api.getUserId()) {
      this.api
        .get('/search-data', {
          office_id: this.api.getOfficeId(),
          user_id: this.api.getUserId(),
          page: 1,
          limit: 99999,
          module: 'users',
        })
        .subscribe({
          next: response => {
            let record = response.data
              .sort(function (a, b) {
                return a?.full_name.localeCompare(b?.full_name);
              })
              .map(result => ({ ...result, category: 'Staff' }));
            this.Users = record;
          },
          error: _ => {
            this.toast.error('Something has gone wrong');
          },
        });
    }
  }

  isSameLevel: boolean = false;
  getParentId = (data: any, id, bool) => {
    // Get the parent id and card id from the selected item in the workflow.
    // Also set the con_id to null and the isSameLevel to the value of bool
    this.parent_id = data?.id;
    this.con_id = null;
    this.card_Id = id;
    this.isSameLevel = bool;
  };
  child: any;
  addNewItemSubLevelView = (data: any) => {
    this.parent_id = data?.id;
    this.child = {
      parent: data?.id,
      id: uuidv4(),
      tigger_title: this.flow.tigger_title,
      trigger_id: this.flow.trigger_id,
      icon: this.display_icon,
      class: '',
      date: this.flow.date,
      isAction: this.flow.isAction,
      tigger_desc: this.flow.tigger_desc,
      update_id: [],
      is_process_stopped: this.flow.is_process_stopped || false,
      update_action_list: [],
      user: {
        user_role: null,
        user: null,
      },
      time: {
        days: '',
        hours: '',
        minutes: '',
        loop: 1,
      },
      clear_ids: [],
      inputfield: [],
      validation: [],
      notification: {
        notification_to: [],
        notify_user: null,
        user: null,
        notify_from: this.flow.trigger_id == '201' ? 'system' : null,
        sender: this.flow.trigger_id == '201' ? [this.api.getOfficeId()] : null,
        subject: '',
        message: '',
      },
      email: {
        email_to: [],
        email_cc: [],
        email_bcc: [],
        user: null,
        subject: '',
        message: '',
      },
      task: {
        title: '',
        job_type: {
          type: null,
          lead: '',
        },
        task_status: null,
        property_project_type: {
          type: '',
          property: null,
          project: null,
          contact: null,
          apartment: '',
        },
        task_calander: {
          recurring_task: '',
          recurring_type: null,
          recurring_end_date: '',
          sync_calender: '',
        },
        staff: [],
        priority: 'low',
        comments: '',
        files: [],
        check_list: [],
      },
      advanced_scheduling: {
        selectedField: null,
        before: { days: '', hours: '', time: '' },
        after: { days: '', hours: '', time: '' },
        on: { time: '' },
      },
    };
    if (this.flow?.type === 'business_rules' || this.flow?.type === 'workflow') {
      this.child = { ...this.flow, ...this.child, parent: data?.id, is_submodule: this.flow.is_submodule };
    }

    if (this.isSameLevel) {
      if (data?.children?.length > 0) {
        data.children.push(this.child);
      } else {
        data['children'] = [this.child];
      }
    } else {
      this.getMyChild(this.flowStackCall);
    }
    this.parent_id = null;
  };

  getMyChild = flowStackCall => {
    // loop through the flowStackCall array and find the parent where the new child will be inserted
    flowStackCall?.forEach(stack => {
      if (stack.id === this.parent_id) {
        // update the parent of the existing children
        let child = stack['children'];

        child.forEach(res => {
          res['parent'] = stack?.id;
        });

        // reset the children array and add the new child to it
        stack['children'] = [];
        this.child.children = child;
        stack.children.push(this.child);
      } else if (stack.children) {
        // if the stack has children, recursively call getMyChild on it
        this.getMyChild(stack.children);
      }
    });
  };

  replaceAll = (string, search, replacement) => {
    // replace all occurrences of search in the string with replacement
    return string.split(search).join(replacement);
  };

  activatedModuleName: string = '';
  activeFlow = (data: any) => {
    this.toggleProcessPane = false;
    this.flowStackCall?.forEach(res => {
      res.class = '';
      res?.children?.forEach(element => {
        element.class = '';
        element.children ? this.removeClass(element) : null;
      });
    });
    if (data?.email?.email_template) {
      let temp = this.emailTemplates.find(temp => temp?._id == data?.email?.email_template);
      this.selected_template = temp;
      ((data.email.message = temp?.body), (data.email.subject = temp?.subject));
    }
    data.class = 'active';
    this.parent_id = null;
    if (!data?.startoperationtime) {
      data.startoperationtime = {
        record_created: false,
        record_status_changes: false,
        record_assigned: false,
        record_fields_change: false,
        record_deleted: false,
      };
    }
    if (data.hasOwnProperty('canStart') == false) {
      data.canStart = true;
    }
    if (data.hasOwnProperty('advanced_scheduling') == false) {
      data.advanced_scheduling = {
        selectedField: null,
        before: { days: '', hours: '', time: '' },
        after: { days: '', hours: '', time: '' },
        on: { time: '' },
      };
    } else if (data.hasOwnProperty('advanced_scheduling') == true && data.advanced_scheduling.hasOwnProperty('on') == false) {
      data.advanced_scheduling.on = { time: '' };
    }
    this.flow_data = data?.module && data?.type?.length > 0 ? { ...data, module: data?.module?.toLowerCase() } : data;
    if (this.flow_data?.module) {
      this.onChangeModule({ name: this.flow_data.module });
      this.ProjectsUnits.selected = this.flow_data?.projects || [];
      this.ProjectsUnits.selected?.length > 0 && this.flow_data.module == 'project_units' && this.onChangeModule({ name: 'Specified Project Units' });
    }
    if (data?.module) {
      this.activatedModuleName = data?.module;
    }
    this.con_id = data.trigger_id;
    if (this.con_id === '107' || this.con_id === '204') {
      if (this.con_id === '107') {
        this.LoadSavedInputfieldConditions();
      }
      this.getEntityField();
    }
    if (data?.trigger_id == '202') {
      if (!data?.email?.email_cc) {
        data.email.email_cc = [];
      }
      if (!data?.email?.email_bcc) {
        data.email.email_bcc = [];
      }
    }

    if (data?.trigger_id == '203') {
      try {
        this._workflowService.GetTaskPriorities().subscribe(response => {
          const { data, status } = response;
          if (status) {
            this.flow_data.task.prioritylist = data;
          }
        });
      } catch (error) {
        this.flow_data.task.prioritylist = [];
      }
    }

    this.condition_input = data?.inputfield?.length > 0 ? data?.inputfield : JSON.parse(this.tempConditionInput);
    this.display_icon = this.flow_data.icon;
  };

  removeClass = response => {
    // Loop through all the child elements and remove the class
    response.children.forEach(element => {
      element.class = '';
      // If the element has children, call the removeClass function recursively
      element.children ? this.removeClass(element) : null;
    });
  };

  changeIconHandler(icon) {
    // Update the display icon
    this.display_icon = icon;
    this.showIcon = false;
    // Update the flow object with the selected icon
    this.flow_data ? (this.flow_data.icon = icon) : null;
    // Check if the icon is an svg file
    this.isSvg = icon.endsWith(`.svg`) ? true : false;
    if (icon) {
      // Update the icon label
      return (this.isIcon = 'Icon Selected');
    }
    // Update the icon label
    return (this.isIcon = 'Icon Selection');
  }

  getActionStatus = eve => {
    // Update the flow object with the selected trigger details
    this.flow.tigger_title = eve.name;
    this.flow.trigger_id = eve.con_id;
    this.flow.is_process_stopped = eve.con_id == '205' ? true : false;
    this.flow.icon = eve.icon;
    this.flow.isAction = !eve.condition;
    this.display_icon = eve.icon;
    if (eve?.type === 'business_rules' || eve?.type === 'workflow') {
      // If the trigger type is business rules or workflow, update the flow object with the selected trigger details
      this.flow = { ...this.flow, ...eve, trigger_id: '1', is_submodule: true };
    }
    // Call the addHandler function to open the trigger card
    this.addHandler();
  };

  addHandler = () => {
    // Trigger card click event when addHandler is called to open the card
    let ele = document.getElementById(this.card_Id);
    if (ele !== null && ele !== undefined) {
      ele.click();
    }
  };
  clearSearch() {
    this.flow.date = null;
  }

  is_email_message: boolean = true;
  is_field_con: boolean = true;

  getDescription = cond => {
    if ((cond.trigger_id === '101' || cond.trigger_id === '103') && cond?.tigger_title?.length > 0) {
      return (
        this._workflowService.module_array.filter(
          res => res.module_value == this.flowStackCall?.[0]?.module || res.module_value == this.flowStackCall?.[0]?.module
        )?.[0]?.name +
        ' ' +
        cond?.tigger_title
      );
    }

    if (cond.trigger_id === '102' && cond.update_id && cond.update_id.length > 0) {
      let desc = [];
      this.entityField.forEach(res => {
        cond.update_id.forEach(ele => {
          if (res._id === ele || res.name === ele) {
            desc.push(res.label);
          }
        });
      });
      return this.replaceAll(desc.toString(), ',', ' | ');
    }

    if (cond.trigger_id === '104' && cond.date) {
      let d = new Date(cond.date);
      let ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(d);
      let mo = new Intl.DateTimeFormat('en', { month: 'long' }).format(d);
      let day = new Intl.DateTimeFormat('en', { day: 'numeric' }).format(d);
      let time = new Intl.DateTimeFormat('en-GB', { hour: '2-digit', minute: '2-digit' }).format(d);
      return `${day} ${mo} ${ye}@${time}`;
    }

    if (cond.trigger_id === '105' && (cond.time.days || cond.time.hours || cond.time.minutes || cond.time.loop || cond.time.watch_field)) {
      const parts: string[] = [];
      let field_label = this.entityField?.find(ele => ele?.name == cond.time.watch_field);
      if (cond.time.days) parts.push(`${cond.time.days} Days`);
      if (cond.time.hours) parts.push(`${cond.time.hours} Hours`);
      if (cond.time.minutes) parts.push(`${cond.time.minutes} Minutes`);
      if (cond.time.loop) parts.push(`${cond.time.loop} Occurrence`);
      if (field_label?.label) parts.push(`Field ${field_label?.label}`);
      return parts.join(', ');
    }

    if (cond.trigger_id === '106' && (cond?.user?.user || cond?.user?.user_role)) {
      let user = '';
      [...this.UsersbyRole, ...this.UserRoles]
        .filter(f => f._id === cond.user.user || f._id === cond.user.user_role)
        .forEach(element => {
          if (element) {
            user += element?.['full_name'] + ' | ';
          }
        });
      return user;
    }

    if (cond.trigger_id === '107' && cond?.inputfield?.length > 0) {
      cond['field_child'] = cond?.inputfield?.flatMap(el => el?.children || []);
      cond['field_child']?.forEach(el => {
        el['left_value'] = el.leftoperator?.replace(/_/g, ' ');
        el['equality_value'] = el.equality?.replace(/_/g, ' ');
      });
    }

    if (cond.trigger_id === '1' && cond.tigger_desc) {
      return `${cond.tigger_desc}`;
    }

    if (cond.trigger_id === '108' && cond.validation && cond.validation.length > 0) {
      let desc = [];
      this.entityField.forEach(res => {
        cond.validation.forEach(ele => {
          if (res.name === ele) {
            desc.push(res.label);
          }
        });
      });
      return this.replaceAll(desc.toString(), ',', ' | ');
    }

    if (cond.trigger_id === '201' && cond?.notification?.subject?.length > 0) {
      return cond?.notification?.subject;
    }

    if (cond.trigger_id === '203' && cond?.task?.title) {
      return cond?.task?.title || 'Task';
    }

    if (cond.trigger_id === '204' && cond?.update_action_list?.length > 0) {
      let displayValue = '';
      cond?.update_action_list?.forEach(element => {
        let result = this.entityField.filter(res => res.name === element.leftoperator)?.[0];
        if (result !== undefined && result !== null && result?.label != '') {
          displayValue += result?.label + ' ';
        }
      });
      return displayValue;
    }

    if (cond.trigger_id === '206' && cond?.clear_ids && cond?.clear_ids?.length > 0) {
      let desc = [];
      this.entityField.forEach(res => {
        cond?.clear_ids?.forEach(ele => {
          if (res._id === ele || res.name === ele) {
            desc.push(res.label);
          }
        });
      });
      return this.replaceAll(desc.toString(), ',', ' | ');
    }

    return '';
  };

  Users: any;
  NotificationUserRoles: any[] = [];
  OfficeContacts: any[] = [];
  OfficeTeams: any[] = [];
  UserRoles: any[] = [];
  UsersbyRole: any[] = [];
  NotifyPropertyFormUsers: any[] = [];
  NotifyUsersSender: any[] = [];

  onChangeUserRole(userRole) {
    // fetch office users by role
    this.UsersbyRole = [];
    this._workflowService.GetAllOfficeUsers().subscribe({
      next: response => {
        const { status, data } = response;
        if (status) {
          // filter users by role
          this.UsersbyRole = data?.filter(result => result?.role_id === userRole?._id);
        }
      },
      error: _ => {
        // if error, reset users by role to empty array
        this.UsersbyRole = [];
      },
    });
  }

  emailSenderList: any[] = [];
  getEmailSenderList() {
    // fetch email sender list
    this._workflowService.GetEmailSenderList().subscribe({
      next: response => {
        const { status, data } = response;
        if (status) {
          this.emailSenderList = data;
        } else {
          this.emailSenderList = [];
        }
      },
      error: _ => {
        // if error, reset email sender list to empty array
        this.emailSenderList = [];
      },
    });
  }

  getFolderFileInformationTooltipHandler(item) {
    // prepare tooltip text
    var info = '';
    if (item?.created_at) {
      info += `<li style='display: table-row;'><span style='display: table-cell;'>Processed:&nbsp;</span>${moment(item?.created_at)?.format('DD MMM YY, hh:mm a')}</li>`;
    }
    if (item?.process_at) {
      info += `<li style='display: table-row;'><span style='display: table-cell;'>Processed:&nbsp;</span>${moment(item?.process_at)?.format('DD MMM YY, hh:mm a')}</li>`;
    }
    return info?.length > 0 ? `<ul class="text-truncate" style='list-style: none;'>${info}</ul>` : 'In-process';
  }

  getEntityField() {
    // Get entity fields for selected module
    this.lmService.selected_workflow ? (this.flowStackCall = [this.lmService.selected_workflow]) : [];
    if (this.flowStackCall?.[0]?.module !== undefined && this.flowStackCall?.[0]?.module != null && this.flowStackCall?.[0]?.module != '') {
      try {
        this._entityManagerService
          .getCollectionField({
            office_id: this.api.getOfficeId(),
            module: this.flowStackCall[0]?.module?.toLowerCase(),
            user_id: this.api.getUserId() ?? null,
          })
          .subscribe({
            next: response => {
              const { data, status, message } = response;
              if (status) {
                // Sort the fields by label
                data?.fields instanceof Array
                  ? (this.entityField = data?.fields.sort(function (a, b) {
                      return a?.label?.trim()?.localeCompare(b?.label?.trim());
                    }))
                  : data?.fields;
                // Filter user fields and map to { ...field, full_name: field.label }
                this.NotifyPropertyFormUsers =
                  this.entityField
                    ?.filter(result => result?.options?.entity === 'users' && result?.format == 9)
                    ?.map(result => ({ ...result, full_name: result?.label })) || [];
                // Set submodule if it exists
                if (this.flow_data?.submodule) {
                  this.selectSubModule({ module_value: this.flow_data?.submodule });
                }
              } else {
                this.toast.error(message ? message : 'Something went wrong');
              }
            },
          });
      } catch (error) {
        this.toast.error('Something went wrong');
      }
    }
  }

  // Create a map to store the computed data
  private userReceiverDataMap: Map<string, any> = new Map<string, any>();

  onChangeNotifyUserReceiver(event, sub_module = '') {
    // Create a key to uniquely identify the combination of event name and sub_module
    const key = event.name + '|' + sub_module;

    // Check if the data is already computed and stored in the map
    if (this.userReceiverDataMap.has(key)) {
      return this.userReceiverDataMap.get(key);
    }

    let data: any;

    // Compute the data based on the event and sub_module
    if (event?.name === 'staff') {
      data = this.Users;
    } else if (event?.name === 'contact') {
      data = this.OfficeContacts;
    } else if (event?.name === 'role') {
      data = this.NotificationUserRoles;
    } else if (event?.name === 'status_based') {
      data = this.NotificationUserRoles;
    } else if (event?.name === 'form') {
      if (sub_module !== '' && sub_module !== null) {
        this.entityField = this.all_module_fields[sub_module].sort(function (a, b) {
          return a?.label?.trim()?.localeCompare(b?.label?.trim());
        });
        data =
          this.entityField
            ?.filter(result => result?.options?.entity === 'users' && result?.format == 9)
            ?.map(result => ({ ...result, full_name: result?.label })) || [];
        data.forEach(element => {
          element._id = element.name;
        });
      } else {
        data = this.NotifyPropertyFormUsers.map(result => ({ ...result, full_name: result?.label }));
        data.forEach(element => {
          element._id = element.name;
        });
      }
    } else if (event?.name === 'team') {
      data = this.OfficeTeams.map(res => ({ ...res, full_name: res.name }));
    } else {
      data = [];
    }

    this.userReceiverDataMap.set(key, data);

    return data;
  }

  onChangeNotifyUserSender(event) {
    // Reset the sender when the notify user sender type is changed
    this.flow_data.notification.sender = null;
    if (event?.name == 'staff') {
      // When the sender type is 'staff', use the original assigns (agents/staff)
      this.NotifyUsersSender = this.Users;
    } else if (event?.name == 'contact') {
      // When the sender type is 'contact', use the office contacts
      this.NotifyUsersSender = this.OfficeContacts;
    } else if (event?.name == 'role') {
      // When the sender type is 'role', use the notification user roles
      this.NotifyUsersSender = this.NotificationUserRoles;
    } else if (event?.name == 'system') {
      // When the sender type is 'system', use the current office id
      this.NotifyUsersSender = null;
      this.flow_data.notification.sender = [this.api.getOfficeId()];
    }
  }

  ProjectsUnits: any = { selected: ([] = []), allunits: [] };
  SpecificModuleListing: any[] = [];
  excludeModuleListing: any[] = [];
  onChangeModule(value) {
    value = { ...value, name: value?.name?.toLowerCase() || '' };
    this.flowStackCall[0].module = this.flow_data.module;
    if (value?.name !== 'Project Lots'?.toLowerCase() || value?.name !== 'project_units'?.toLowerCase()) {
      this.flow.filter = this.SpecificModuleListing = this.excludeModuleListing = [];
    }
    if (value?.name == 'Property'?.toLowerCase() || value?.name == 'properties_data'?.toLowerCase()) {
      this.ProjectsUnits.allunits = [];
      this._workflowService.GetPropertyModuleListDetail().subscribe({
        next: response => {
          if (response?.['status']) {
            this.SpecificModuleListing = [...this.SpecificModuleListing, { _id: 'all', property_address: 'All' }, ...response?.data]?.map(result => ({
              ...result,
              name: result?.property_address,
            }));
            this.SpecificModuleListing = this.SpecificModuleListing.filter(f => f.name !== null && f.name !== undefined);
            this.flow_data.readonlyfilter = this.flow_data.readonlyfilter.filter(element =>
              this.SpecificModuleListing.some(obj => element == 'all' || obj._id === element)
            );
            this.excludeModuleListing = [...this.excludeModuleListing, ...response?.data]?.map(result => ({
              ...result,
              name: result?.property_address,
            }));
            this.excludeModuleListing = this.excludeModuleListing.filter(f => f.name !== null && f.name !== undefined);
          }
        },
        error: _ => {
          this.SpecificModuleListing = [];
          this.excludeModuleListing = [];
        },
      });
    }
    if (value?.name == 'Listing'?.toLowerCase() || value?.name == 'properties'?.toLowerCase()) {
      this.ProjectsUnits.allunits = [];
      this._workflowService.GetLisitingModuleListDetail().subscribe({
        next: response => {
          if (response?.['status']) {
            this.SpecificModuleListing = [...this.SpecificModuleListing, { _id: 'all', property_address: 'All' }, ...response?.data]?.map(result => ({
              ...result,
              name: result?.property_address,
            }));
            this.SpecificModuleListing = this.SpecificModuleListing.filter(f => f.name !== null && f.name !== undefined);
            this.flow_data.readonlyfilter = this.flow_data?.readonlyfilter?.filter(element =>
              this.SpecificModuleListing.some(obj => element == 'all' || obj._id === element)
            );
            this.excludeModuleListing = [...this.excludeModuleListing, ...response?.data]?.map(result => ({
              ...result,
              name: result?.property_address,
            }));
            this.excludeModuleListing = this.excludeModuleListing.filter(f => f.name !== null && f.name !== undefined);
          }
        },
        error: _ => {
          this.SpecificModuleListing = [];
          this.excludeModuleListing = [];
        },
      });
    } else if (value?.name == 'Projects'?.toLowerCase() || value?.name == 'projects'?.toLowerCase()) {
      this.ProjectsUnits.allunits = [];
      this._workflowService.GetProjectModuleListDetail().subscribe({
        next: response => {
          if (response?.['status']) {
            this.SpecificModuleListing = [...this.SpecificModuleListing, { _id: 'all', Project_Name: 'All' }, ...response?.data]?.map(result => ({
              ...result,
              name: result?.Project_Name,
            }));
            this.flow_data.readonlyfilter = this.flow_data.readonlyfilter.filter(element =>
              this.SpecificModuleListing.some(obj => element == 'all' || obj._id === element)
            );
            this.excludeModuleListing = [...this.excludeModuleListing, ...response?.data]?.map(result => ({ ...result, name: result?.Project_Name }));
          }
        },
        error: _ => {
          this.SpecificModuleListing = [];
          this.excludeModuleListing = [];
        },
      });
    } else if (value?.name == 'Contact'?.toLowerCase() || value?.name == 'contacts'?.toLowerCase()) {
      this.ProjectsUnits.allunits = [];
      this._workflowService.GetContactModuleListDetail().subscribe({
        next: response => {
          if (response?.['status']) {
            this.SpecificModuleListing = [...this.SpecificModuleListing, { _id: 'all', full_name: 'All' }, ...response?.data]?.map(result => ({
              ...result,
              name: result?.full_name,
            }));
            this.flow_data.readonlyfilter = this.flow_data.readonlyfilter.filter(element =>
              this.SpecificModuleListing.some(obj => element == 'all' || obj._id === element)
            );
            this.excludeModuleListing = [...this.excludeModuleListing, ...response?.data]?.map(result => ({ ...result, name: result?.full_name }));
          }
        },
        error: _ => {
          this.SpecificModuleListing = [];
          this.excludeModuleListing = [];
        },
      });
    } else if (value?.name == 'Tasks'?.toLowerCase() || value?.name == 'tasks'?.toLowerCase()) {
      this.ProjectsUnits.allunits = [];
      this._workflowService.GetTaskModuleListDetail().subscribe({
        next: response => {
          if (response?.['status']) {
            this.SpecificModuleListing = [...this.SpecificModuleListing, { _id: 'all', title: 'All' }, ...response?.data]?.map(result => ({
              ...result,
              name: result?.title,
            }));
            this.flow_data.readonlyfilter = this.flow_data.readonlyfilter.filter(element =>
              this.SpecificModuleListing.some(obj => element == 'all' || obj._id === element)
            );
            this.excludeModuleListing = [...this.excludeModuleListing, { _id: 'all', title: 'All' }, ...response?.data]?.map(result => ({
              ...result,
              name: result?.title,
            }));
          }
        },
        error: _ => {
          this.SpecificModuleListing = [];
          this.excludeModuleListing = [];
        },
      });
    } else if (value?.name == 'Lead Management'?.toLowerCase() || value?.name == 'lead_management'?.toLowerCase()) {
      this.ProjectsUnits.allunits = [];
      this._workflowService.GetLeadManagementModuleListDetail().subscribe({
        next: response => {
          if (response?.['status']) {
            this.SpecificModuleListing = [...this.SpecificModuleListing, { _id: 'all', first_name: 'All' }, ...response?.data]?.map(result => ({
              ...result,
              name: result?.first_name || '' + ' ' + result?.last_name || '',
              process: 'play',
            }));
            this.excludeModuleListing = [...this.excludeModuleListing, { _id: 'all', first_name: 'All' }, ...response?.data]?.map(result => ({
              ...result,
              name: result?.first_name || '' + ' ' + result?.last_name || '',
              process: 'play',
            }));
          }
          this.flow_data.readonlyfilter = this.flow_data.readonlyfilter.filter(element =>
            this.SpecificModuleListing.some(obj => element == 'all' || obj._id === element)
          );
        },
        error: _ => {
          this.SpecificModuleListing = [];
          this.excludeModuleListing = [];
        },
      });
    } else if (value?.name == 'Project Lots'?.toLowerCase() || value?.name == 'project_units'?.toLowerCase()) {
      this.ProjectsUnits.allunits = [];
      this._workflowService.GetProjectModuleListDetail().subscribe({
        next: response => {
          if (response?.['status']) {
            this.ProjectsUnits.allunits = [...this.ProjectsUnits.allunits, { _id: 'all', Project_Name: 'All' }, ...response?.data]?.map(result => ({
              ...result,
              name: result?.Project_Name,
            }));
            this.ProjectsUnits.selected = this.ProjectsUnits.selected.filter(element =>
              this.ProjectsUnits?.allunits.some(obj => element == 'all' || obj._id == element)
            );
          }
        },
        error: _ => {
          this.ProjectsUnits.allunits = [];
        },
      });
    } else if (value?.name == 'Specified Project Units'?.toLowerCase()) {
      this._workflowService.GetProjectUnitsModuleListDetail(this.ProjectsUnits?.selected).subscribe({
        next: response => {
          if (response?.['status']) {
            this.SpecificModuleListing = [...this.SpecificModuleListing, { _id: 'all', lot_name: 'All' }, ...response?.data]?.map(result => ({
              ...result,
              name: result?.lot_name,
            }));
            this.excludeModuleListing = [...this.excludeModuleListing, { _id: 'all', lot_name: 'All' }, ...response?.data]?.map(result => ({
              ...result,
              name: result?.lot_name,
            }));
            this.flow_data.projects = this.ProjectsUnits.selected;
            this.flow_data.readonlyfilter = this.flow_data.readonlyfilter.filter(element =>
              this.SpecificModuleListing.some(obj => element == 'all' || obj._id === element)
            );
          }
        },
        error: _ => {
          this.SpecificModuleListing = [];
          this.excludeModuleListing = [];
        },
      });
    } else if (value?.name == 'Contract'?.toLowerCase() || value?.name == 'contract'?.toLowerCase()) {
      this.ProjectsUnits.allunits = [];
      this._workflowService.GetContractModuleListDetail().subscribe({
        next: response => {
          if (response?.['status']) {
            this.SpecificModuleListing = [...this.SpecificModuleListing, { _id: 'all', listing_name: 'All' }, ...response?.data]?.map(result => ({
              ...result,
              name: result?.listing_name,
              process: 'play',
            }));
            this.SpecificModuleListing = this.SpecificModuleListing.filter(f => f.name !== undefined && f.name !== null);
            this.flow_data.readonlyfilter = this.flow_data.readonlyfilter.filter(element =>
              this.SpecificModuleListing.some(obj => element == 'all' || obj._id === element)
            );
            this.excludeModuleListing = [...this.excludeModuleListing, ...response?.data]?.map(result => ({
              ...result,
              name: result?.listing_name,
              process: 'play',
            }));
            this.excludeModuleListing = this.excludeModuleListing.filter(f => f.name !== undefined && f.name !== null);
          }
        },
        error: _ => {
          this.SpecificModuleListing = [];
          this.excludeModuleListing = [];
        },
      });
    } else {
      this.SpecificModuleListing = [];
      this.excludeModuleListing = [];
    }
  }

  removeItem(arr, id) {
    // removes item with given id from array and recursively from children
    return arr
      .filter(el => el.id !== id)
      .map(el => {
        if (!el.children || !Array.isArray(el.children)) return el;
        el.children = this.removeItem(el.children, id);
        return el;
      });
  }

  getTrigger = eve => {
    // eve is the current element in the flow stack
    // we get the entity fields and all module fields
    // we then set the parent_id and con_id to null
    this.flowStackCall = eve;
    this.getEntityField();
    this.getAllModuleFields();
    this.activeFlow(this.flowStackCall[0]);
    this.parent_id = null;
    this.con_id = null;
    this.getEmailTemplate();
  };

  AddNewItemSameLevel(data: any, isAdding = false) {
    // if parent is -1, it means we are trying to add a new root node
    // if parent is -2, it means we are trying to delete the root node
    if (data?.parent < 0) {
      if (isAdding == false && data?.parent == -1) {
        this.toast.error('Unable to delete parent node');
        return;
      } else if (isAdding == false) {
        this.addOrRemoveItemInParentNode(this.condition_input, data?.id, isAdding ? null : data?.id);
      } else {
        // add new root node
        this.condition_input.push({
          parent: this.condition_input[this.condition_input.length - 1].parent - 1,
          id: uuidv4(),
          iscondition: true,
          condition_id: 1,
        });
      }
    } else {
      this.addOrRemoveItemInParentNode(this.condition_input, data?.parent, isAdding ? null : data?.id);
    }
  }

  changeSave(event, condition) {
    condition['rightoperator'] = null;
    ``;
    if (event?.format === 1) {
      condition['format'] = 'format1';
      condition['isAddressBar'] = event?.name === 'property_address' ? true : false;
    } else if (event?.format === 2 || event?.format == 203) {
      condition['format'] = 'format2';
    } else if (event?.format === 3 || event?.format == 302) {
      condition['format'] = 'format3';
    } else if (event?.format === 4) {
      condition['format'] = 'format4';
    } else if (event?.format === 7) {
      condition['format'] = 'format7';
    } else if (event?.format === 8) {
      condition['format'] = 'format8';
    } else if (event?.format == 502) {
      const { role_based_enumlist } = event;
      condition['bindfield'] = '_id';
      let statusArray = [];
      for (let role_based of role_based_enumlist.admins) {
        statusArray.push({ _id: role_based, name: role_based });
      }
      condition['statusArray'] = statusArray;
      condition['format'] = 'format502';
    } else if (event?.format === 5 || event?.format === 6 || event?.format === 9) {
      const { entity, entityid, filter, label_field, value_field, entityName } = event?.options;
      condition['bindfield'] = value_field || '_id';
      if (event?.name == 'listing_status' || event?.name == 'listing_type' || event?.name == 'property_type' || event?.name == 'property_status') {
        this.GetTagManagerPropertyFields(event?.name, condition);
      } else if (event?.name == 'contractStatus') {
        this._contractService.getContractStatusList().subscribe({
          next: response => {
            condition['statusArray'] = response[0]?.name
              ? response?.sort(function (a, b) {
                  return a?.name?.localeCompare(b?.name);
                })
              : response
                  ?.map(result => ({ ...result, name: result?.[label_field] }))
                  .sort(function (a, b) {
                    return a?.name?.localeCompare(b?.name);
                  });
            condition['format'] = 'format5or6';
          },
          error: _ => {
            this.toast.error('Something went wrong');
          },
        });
      } else {
        if (entity === 'users') {
          this._workflowService.GetUserEntities(filter).subscribe({
            next: response => {
              condition['statusArray'] = response?.data[0]?.name
                ? response?.data.sort(function (a, b) {
                    return a?.name?.localeCompare(b?.name);
                  })
                : response?.data
                    ?.map(result => ({ ...result, name: result?.[label_field] }))
                    .sort(function (a, b) {
                      return a?.name?.localeCompare(b?.name);
                    });
              condition['format'] = 'format5or6';
            },
            error: _ => {
              this.toast.error('Something went wrong');
            },
          });
        } else if (entityName?.toLowerCase() == 'tag manager') {
          if (event?.name == 'status_reason' || event?.name == 'status_reason_2' || event?.name == 'status_code') {
            this._workflowService.getProjectStatusFromTagManager().subscribe({
              next: response => {
                condition['statusArray'] = response?.data[0]?.name
                  ? response?.data.sort(function (a, b) {
                      return a?.name?.localeCompare(b?.name);
                    })
                  : response?.data
                      ?.map(result => ({ ...result, name: result?.[label_field] }))
                      .sort(function (a, b) {
                        return a?.name?.localeCompare(b?.name);
                      });
                condition['format'] = 'format5or6';
              },
              error: _ => {
                this.toast.error('Something went wrong');
              },
            });
          } else {
            if (event?.name == 'tags') {
              this._workflowService.GetTagsByModule(event?.options?.moduleslug).subscribe({
                next: response => {
                  if (response?.data?.length > 0) {
                    response.data = response?.data?.map(itm => ({ ...itm, name: itm.tag_name }));
                  }
                  condition['statusArray'] = response?.data[0]?.name
                    ? response?.data.sort(function (a, b) {
                        return a?.name?.localeCompare(b?.name);
                      })
                    : response?.data
                        ?.map(result => ({ ...result, name: result?.[label_field] }))
                        .sort(function (a, b) {
                          return a?.name?.localeCompare(b?.name);
                        });
                  condition['format'] = 'format5or6';
                },
                error: _ => {
                  this.toast.error('Something went wrong');
                },
              });
            } else {
              this._workflowService.GetTagsByFilter(event?.options?.moduleslug, event?.options?.typeslug).subscribe({
                next: response => {
                  if (response?.data?.length > 0) {
                    response.data = response?.data?.map(itm => ({ ...itm, name: itm.tag_name }));
                  }
                  condition['statusArray'] = response?.data[0]?.name
                    ? response?.data.sort(function (a, b) {
                        return a?.name?.localeCompare(b?.name);
                      })
                    : response?.data
                        ?.map(result => ({ ...result, name: result?.[label_field] }))
                        .sort(function (a, b) {
                          return a?.name?.localeCompare(b?.name);
                        });
                  condition['format'] = 'format5or6';
                },
                error: _ => {
                  this.toast.error('Something went wrong');
                },
              });
            }
          }

          condition['statusArray'] = condition['statusArray']?.filter(result => result?.module_id == entityid);
        } else {
          this._workflowService.GetEntitiesById(entityid).subscribe({
            next: response => {
              condition['statusArray'] = response?.data[0]?.name
                ? response?.data.sort(function (a, b) {
                    return a?.name?.localeCompare(b?.name);
                  })
                : response?.data
                    ?.map(result => ({ ...result, name: result?.[label_field]?.toString() }))
                    .sort(function (a, b) {
                      return a?.name?.localeCompare(b?.name);
                    });
              condition['format'] = 'format5or6';
            },
            error: _ => {
              this.toast.error('Something went wrong');
            },
          });
        }
      }
    }
  }
  getAgentName(event, condition) {
    // Get the agent name from the event object and update the condition object
    if (event?.role_id) {
      return (condition['agent_name'] = event?.full_name);
    }
  }
  GetTagManagerPropertyFields(tagType: String = '', condition) {
    try {
      return new Promise((resolve, reject) => {
        // Get the tag manager information
        this._workflowService.GetTagManagerInformation(this.api.getOfficeId()).subscribe({
          next: response => {
            if (response?.status) {
              let record = response?.data[0];
              if (record) {
                const { types } = record;
                let listing_status = types?.filter(result => result.slug == tagType.replace('_', '-'))?.[0];
                if (tagType == 'property_status') {
                  tagType = 'listing_status';
                }
                let property_status = types?.filter(result => result.slug == tagType.replace('_', '-'))?.[0];
                let property_type = types?.filter(result => result.slug == tagType.replace('_', '-'))?.[0];
                if (listing_status && listing_status?.slug === tagType.replace('_', '-')) {
                  // Get the status array from the tag manager response
                  condition['statusArray'] = listing_status?.data
                    ?.map(res => ({ ...res, name: res?.tag_name }))
                    ?.sort(function (a, b) {
                      return a?.tag_name?.localeCompare(b?.tag_name);
                    });
                } else if (property_status && property_status?.slug === tagType.replace('_', '-')) {
                  // Get the status array from the tag manager response
                  condition['statusArray'] = property_status?.data
                    ?.map(res => ({ ...res, name: res?.tag_name }))
                    ?.sort(function (a, b) {
                      return a?.tag_name?.localeCompare(b?.tag_name);
                    });
                } else if (property_type && property_type?.slug === tagType.replace('_', '-')) {
                  // Get the status array from the tag manager response
                  condition['statusArray'] = property_type?.data
                    ?.map(res => ({ ...res, name: res?.tag_name }))
                    ?.sort(function (a, b) {
                      return a?.tag_name?.localeCompare(b?.tag_name);
                    });
                }
              } else {
                condition['statusArray'] = [];
              }
              condition['format'] = 'format5or6';
              resolve(response);
            }
          },
          error: error => {
            this.toast.error(error?.message ? error?.message : 'Something went wrong');
            reject();
          },
        });
      });
    } catch (error) {
      this.toast.error(error?.message ? error?.message : 'Something went wrong');
    }
  }

  GetFieldName = id => {
    // Returns the name of the condition or action based on the given id
    return (
      this._workflowService.condition_array.filter(res => res.con_id === id)?.[0]?.name ||
      this._workflowService.action_list.filter(res => res.con_id === id)?.[0]?.name
    );
  };
  submitted: boolean = false;
  updateHandler = () => {
    if (this.flow_data?.is_child_trigger == true) {
      this.flowStackCall[0].is_child_trigger = true;
      this.flowStackCall[0].canStart = false;
      this.flowStackCall[0].startoperationtime.record_created = false;
      this.flowStackCall[0].startoperationtime.record_fields_change = false;
      this.flowStackCall[0].startoperationtime.record_deleted = false;
    }
    this.flowStackCall[0].exclude_records = this.flow_data?.exclude_records;
    this.flowStackCall[0].is_child_trigger = this.flow_data?.is_child_trigger;
    // Validation for email notification
    if (
      this.con_id == 201 &&
      (!this.flow_data.notification.notification_to?.length ||
        (this.flow_data.notification.notification_to?.length > 0 && this.flow_data.notification.notification_to[0]?.notify_user == null) ||
        this.flow_data.notification.notify_from == null ||
        this.flow_data.notification.subject == '' ||
        this.flow_data.notification.message == '')
    ) {
      this.toast.error('Fill the required field');
    } else {
      let processClone = {};
      let triggerValue: {
        workflow_type: 'workflow' | 'business_rules';
        title: string;
        icon: string;
        module: string;
        filter?: any[];
        readonlyfilter?: string[];
        description: string;
        startoperationtime: any;
        projects?: any;
        can_start: any;
        children: any[];
      } = null;
      if (this._workflowService.processRecordId && this.lmService.selected_workflow) {
        if (Array.isArray(this.flowStackCall?.[0]?.filter) && this.flowStackCall?.[0]?.filter?.length > 0) {
          let isIndexExists = this.flowStackCall?.[0]?.filter?.findIndex(value => value?._id === this._workflowService.processRecordId);
          if (isIndexExists < 0) {
            let newItem: { _id: string; process: string } = { _id: this._workflowService.processRecordId, process: 'stop' };
            this.flowStackCall?.[0]?.filter?.push(newItem);
            triggerValue = { ...triggerValue, filter: [{ ...newItem, process: 'play' }], readonlyfilter: [this._workflowService.processRecordId] };
          } else {
            let newItem: { _id: string; process: string } = { _id: this._workflowService.processRecordId, process: 'play' };
            this.flowStackCall[0].filter[isIndexExists].process = 'stop';
            this.flowStackCall[0].readonlyfilter[isIndexExists] = this.flowStackCall[0].readonlyfilter[isIndexExists]?.filter(
              value => value !== this._workflowService.processRecordId
            );
            triggerValue = { ...triggerValue, filter: [{ ...newItem }], readonlyfilter: [this._workflowService.processRecordId] };
          }
        }
        const { canStart, tigger_desc, icon, module, startoperationtime, tigger_title, type, projects, children } = this.flowStackCall?.[0];
        triggerValue = {
          ...(triggerValue || {}),
          can_start: canStart || null,
          description: tigger_desc || null,
          icon: icon || null,
          module: module || null,
          startoperationtime: startoperationtime || null,
          title: tigger_title + ' copy' || null,
          workflow_type: type || null,
          projects: projects || null,
          children: children,
        };
        processClone = { ...processClone, filter: this.flowStackCall?.[0]?.filter, readonlyfilter: this.flowStackCall?.[0]?.readonlyfilter };
      }
      this.flowStackCall[0]['projects'] = this.flow_data?.projects;
      this.api
        .put('/workflow/update/' + this.flowStackCall[0]['_id'], Object.keys(processClone)?.length > 0 ? processClone : this.flowStackCall[0])
        .subscribe({
          next: _ => {
            this.toast.success('Flow updated successfully');
            this.leftFlowComponent.getFlow();
            const { can_start, description, filter, icon, module, readonlyfilter, startoperationtime, title, workflow_type, projects, children } =
              triggerValue;
            this.leftFlowComponent.triggerPublish(null, {
              can_start,
              description,
              filter,
              icon,
              module,
              readonlyfilter,
              startoperationtime,
              title,
              workflow_type,
              projects,
              children,
            });
            this._workflowService.isWorkflowOpened = false;
          },
          error: _ => {
            this.toast.error('Something has gone wrong');
          },
        });
    }
  };

  selectSubModule(e) {
    // Get the fields for the selected module
    let data = {
      module: e.module_value,
      office_id: this.api.getOfficeId(),
      user_id: this.api.getUserId(),
    };
    this._entityManagerService.getCollectionField(data).subscribe({
      next: response => {
        if (response && response.data && response.data.fields) {
          // Sort the fields by label
          this.entityField = response.data?.fields.sort(function (a, b) {
            return a?.label?.trim()?.localeCompare(b?.label?.trim());
          });
          // Filter the fields that are of type 'users' and format '9'
          this.NotifyPropertyFormUsers =
            this.entityField
              ?.filter(result => result?.options?.entity === 'users' && result?.format == 9)
              ?.map(result => ({ ...result, full_name: result?.label })) || [];
        }
      },
    });
  }

  selectTemplate(e) {
    // Get the fields for the selected module
    let data = {
      module: e.module_value,
      office_id: this.api.getOfficeId(),
      user_id: this.api.getUserId(),
    };
    this._entityManagerService.getCollectionField(data).subscribe({
      next: response => {
        if (response && response.data && response.data.fields) {
          let fields = response.data.fields;
          let usersFields = [];
          for (let field of response.data.fields) {
            if (field.options?.entity == 'users') {
              let forFirstName = { ...field };
              let forLastName = { ...field };
              forFirstName.label = `${forFirstName.label} First Name`;
              forFirstName.name = `${forFirstName.name}.first_name`;
              forLastName.label = `${forLastName.label} Last Name`;
              forLastName.name = `${forLastName.name}.last_name`;
              usersFields.push(forFirstName);
              usersFields.push(forLastName);
            }
          }
          // Combine the fields with the users fields
          this.leadFields = [...fields, ...usersFields];
          // Sort the fields by name
          this.leadFields = this.leadFields.sort(function (a, b) {
            if (a.name < b.name) {
              return -1;
            }
            if (a.name > b.name) {
              return 1;
            }
            return 0;
          });
        }
      },
    });
    // Get the email templates for the selected module
    this.emailTemplates = this.emailTemplatesCopy;
    this.emailTemplates = this.emailTemplates?.filter(x => x.type == (e.module_value === 'tasks' ? 'task' : e.module_value));
  }

  leadFields: any = [];
  emailTemplates: any;
  emailTemplatesCopy: any;
  template: any;
  getEmailTemplate() {
    // Fetch email templates based on office ID and store them
    this._sharedService.getEmailTemplate().subscribe({
      next: response => {
        this.emailTemplates = response.data;
        this.emailTemplatesCopy = response.data;
      },
    });
  }

  selected_template: any;
  getTemplateBody(temp) {
    // When a template is selected, the body and subject of the email are set to the template's values
    // The email_from field is set to the email account associated with the template
    console.log('template_event >>:', temp);
    this.selected_template = temp;
    ((this.flow_data.email.message = temp?.body), (this.flow_data.email.subject = temp?.subject));
    this.flow_data.email['email_template'] = temp?._id;
    this.flow_data.email.email_from = temp?.email_account ? temp?.email_account : '';
  }

  addNewLeadEmail() {
    // Save the current email template to the email template list
    // This is useful if the user wants to save a template that they have modified
    // inside an automation. This template will be available in the email template dropdown
    let temp_body = {
      body: this.flow_data.email.message,
      name: this.selected_template?.name,
      subject: this.selected_template?.subject,
      type: this.selected_template?.type,
      email_account: this.selected_template?.email_account,
      office_id: this.api.getOfficeId(),
      user_id: this.api.getUserId(),
    };
    this.api.put('/settings/email-template/' + this.selected_template?._id, temp_body).subscribe({
      next: response => {
        this.toast.success(response.message);
        this.getEmailTemplate();
      },
    });
  }

  copyHandler = eve => {
    // Copy the event name to clipboard with a custom message
    copy(`{${eve}}`, {
      debug: true,
      message: 'Press #{key} to copy',
    });
  };

  isLeftPaneExpanded: boolean = true;
  LeftPanelExpandedStatus(status) {
    // Set the left pane expanded status
    this.isLeftPaneExpanded = status;
  }
  CloseProcessPane(event) {
    // Close the process pane when a process is selected
    // and update the workflow stack with the selected process
    if (event) {
      this.flowStackCall = this._workflowService.TaskList?.data?.filter(res => res?._id === this.flowStackCall[0]?._id);
      this.toggleProcessPane = !this.toggleProcessPane;
      this.toggleProcessPaneObservable.next(this.toggleProcessPane);
    }
  }

  isItTag: boolean = false;
  isSubject: boolean = false;
  triggerEmitter = (name, bol) => {
    this.isItTag = !this.isItTag;
    if (bol) {
      // Add the selected field to the Notification Subject or Message
      if (this.isSubject == true) {
        this.flow_data.notification.subject = this.flow_data.notification.subject + ` {${name}}`;
      } else {
        // Get the current cursor position in the editor
        const editorInstance = this.editorRef.editorInstance;
        if (editorInstance) {
          const cursorPosition = editorInstance.model.document.selection.getFirstPosition();
          // Insert the selected field at the current cursor position
          editorInstance.model.change(writer => {
            writer.insertText(`{${name}}`, cursorPosition);
          });
          // Update the notification message with the inserted field
          this.flow_data.notification.message = editorInstance.data.get();
        } else {
          console.error('CKEditor instance is not available.');
        }
      }
    } else {
      // Add the selected field to the Email Subject or Message
      if (this.isSubject == true) {
        this.flow_data.email.subject = this.flow_data.email.subject + ` {${name}}`;
      } else {
        // Get the current cursor position in the editor
        const editorInstance = this.editorRef.editorInstance;
        if (editorInstance) {
          const cursorPosition = editorInstance.model.document.selection.getFirstPosition();
          // Insert the selected field at the current cursor position
          editorInstance.model.change(writer => {
            writer.insertText(`{${name}}`, cursorPosition);
          });
          // Update the email message with the inserted field
          this.flow_data.email.message = editorInstance.data.get();
        } else {
          console.error('CKEditor instance is not available.');
        }
      }
    }
  };

  addOrRemoveFieldNotificationToAction(action = 'add', field) {
    // This function is used to add or remove fields from the Notification To List in the workflow.
    // If the action is 'add', it will add a new field to the list if there are no existing fields with a null notify_user value.
    // If the action is 'remove', it will remove the field from the list that matches the id of the field passed in.
    if (action == 'add') {
      if (this.flow_data?.notification.hasOwnProperty('notification_to') == false) {
        this.flow_data.notification.notification_to = [];
      }
      if (
        this.flow_data?.notification?.notification_to?.filter(res => res?.notify_user === null)?.length > 0 &&
        this.flow_data?.notification?.notification_to?.length > 0
      ) {
        return;
      }
      this.flow_data?.notification?.notification_to?.push({ id: uuidv4(), notify_user: null, user: null });
    } else {
      let elementPos = this.flow_data?.notification?.notification_to?.map(value => value?.id).indexOf(field?.id);
      this.flow_data?.notification?.notification_to?.splice(elementPos, 1);
    }
  }

  addOrRemoveFieldEmailToAction(action = 'add', field) {
    // This function is used to add or remove fields from the Email To List in the workflow.
    // If the action is 'add', it will add a new field to the list if there are no existing fields with a null leftoperator.
    // If the action is 'remove', it will remove the field from the list that matches the id of the field passed in.
    if (action == 'add') {
      // Check if there is an existing field with a null 'to' value
      if (this.flow_data?.email?.email_to?.filter(res => res?.to === null)?.length > 0 && this.flow_data?.email?.email_to?.length > 0) {
        return;
      }
      // Add a new field to the list
      this.flow_data?.email?.email_to?.push({ id: uuidv4(), to: null, user: null });
    } else {
      // Remove the field from the list that matches the id of the field passed in
      let elementPos = this.flow_data?.email?.email_to?.map(value => value?.id).indexOf(field?.id);
      this.flow_data?.email?.email_to?.splice(elementPos, 1);
    }
  }

  addOrRemoveFieldEmailCCAction(action = 'add', field) {
    // This function is used to add or remove fields from the Email CC List in the workflow.
    // If the action is 'add', it will add a new field to the list if there are no existing fields with a null left operator.
    // If the action is 'remove', it will remove the field from the list that matches the id of the field passed in.
    if (action == 'add') {
      if (this.flow_data?.email?.email_cc?.filter(res => res?.to === null)?.length > 0 && this.flow_data?.email?.email_cc?.length > 0) {
        return;
      }
      this.flow_data?.email?.email_cc?.push({ id: uuidv4(), to: null, user: null });
    } else {
      let elementPos = this.flow_data?.email?.email_cc?.map(value => value?.id).indexOf(field?.id);
      this.flow_data?.email?.email_cc?.splice(elementPos, 1);
    }
  }

  addOrRemoveFieldEmailBCCAction(action = 'add', field) {
    // This function is used to add or remove fields from the Email BCC List in the workflow.
    // If the action is 'add', it will add a new field to the list if there are no existing fields with a null leftoperator.
    // If the action is 'remove', it will remove the field from the list that matches the id of the field passed in.
    if (action == 'add') {
      if (this.flow_data?.email?.email_bcc?.filter(res => res?.to === null)?.length > 0 && this.flow_data?.email?.email_bcc?.length > 0) {
        return;
      }
      this.flow_data?.email?.email_bcc?.push({ id: uuidv4(), to: null, user: null });
    } else {
      let elementPos = this.flow_data?.email?.email_bcc?.map(value => value?.id).indexOf(field?.id);
      this.flow_data?.email?.email_bcc?.splice(elementPos, 1);
    }
  }

  AddorRemoveFieldUpdateAction(action = 'add', field) {
    // This function is used to add or remove fields from the Update Action List in the workflow.
    // If the action is 'add', it will add a new field to the list if there are no existing fields with a null leftoperator.
    // If the action is 'remove', it will remove the field from the list that matches the id of the field passed in.
    if (action == 'add') {
      if (this.flow_data.update_action_list.filter(res => res?.leftoperator === null)?.length > 0 && this.flow_data.update_action_list?.length > 0) {
        return;
      }
      this.flow_data.update_action_list.push({ id: uuidv4(), leftoperator: null, format: '', rightoperator: null });
    } else {
      let elementPos = this.flow_data.update_action_list.map(value => value?.id).indexOf(field?.id);
      this.flow_data.update_action_list.splice(elementPos, 1);
    }
  }

  // create Task

  jobTypes: any[] = [];
  leads: any[] = [];
  showLeads: boolean = false;
  taskStatuses: any[] = [];
  public logoUrl = [];
  public logos = null;
  newItem = '';
  checkItemToEdit = null;

  jobtypeHandler = eve => {
    // When the job type is selected as "Lead Management", retrieve the list of leads
    if (eve.name === 'Lead Management') {
      let queryParams: any = {};
      queryParams = { entityname: 'leads' };
      queryParams.userid = this.api.getUserId();
      queryParams.officeid = this.api.getOfficeId();
      this.api.get('/eng/misc/entity/getallbyname', queryParams).subscribe({
        next: response => {
          this.leads = response['data'];
          this.leads.map(lead => (lead.full_name = lead?.first_name + ' ' + lead?.last_name));
          this.showLeads = true;
        },
      });
    } else {
      this.showLeads = false;
    }
  };

  onLogoSelect(event) {
    // Handles the selection/upload of logos
    if (this.logos == null) {
      this.logos = [];
      this.logoUrl = [];
    }
    if (event.target.files && event.target.files.length) {
      for (let i = 0; i < event.target.files.length; i++) {
        let logoName = event.target.files[i].name;
        const fileReader: FileReader = new FileReader();
        fileReader.readAsDataURL(event.target.files[i]);
        fileReader.onload = () => {
          this.logoUrl.push(this.sanitizer.bypassSecurityTrustUrl(<any>fileReader.result));
          this.logos.push({ name: logoName, file: fileReader.result });
          // Set the task files to the selected logos
          this.flow_data.task.files = this.logoUrl;
        };
      }
    }
  }

  addCheckListItem() {
    // Edit or add checklist item
    if (this.checkItemToEdit !== null) {
      // Editing existing item
      this.flow_data.task.check_list[this.checkItemToEdit] = this.newItem;
      this.checkItemToEdit = null;
    } else {
      // Adding new item
      this.flow_data.task.check_list.push(this.newItem);
    }
    // Reset input
    this.newItem = '';
  }

  drop(event: CdkDragDrop<string[]>) {
    // Move checklist item from one index to another
    const moveIt = this.flow_data.task.check_list[event.previousIndex];
    const withId = event.currentIndex;
    this.flow_data.task.check_list[event.previousIndex] = this.flow_data.task.check_list[withId];
    this.flow_data.task.check_list[withId] = moveIt;
  }

  onChangeUnit = _ => {
    // When changing the unit, we need to update the filter and readonlyfilter in both flow_data and flowStackCall
    // We do this by filtering the filter array to only include items that are in the readonlyfilter array
    // and then updating the filter and readonlyfilter in both flow_data and flowStackCall
    let tempFilter: any[] = [];
    this.flow_data.readonlyfilter.forEach(element => {
      let filteredItem: any = this.flow_data['filter'].filter(res => res.id == element);
      if (filteredItem) {
        tempFilter.push({ _id: element, process: filteredItem?.process || 'play' });
      }
    });
    this.flow_data.filter = tempFilter;
    this.flowStackCall[0].filter = tempFilter;
    this.flowStackCall[0].readonlyfilter = this.flow_data.readonlyfilter;
  };

  //#region SavedCOnditionInputField

  inputfieldConditionType: any = { isLoadSelected: false, SavedConditions: [], title_resolver: null };

  ResetFormFields() {
    // Reset form fields when loading new condition
    this.inputfieldConditionType = { isLoadSelected: false, SavedConditions: [], title_resolver: null };
  }
  changeDateFormat(con) {
    // Format selected date to 'yyyy-MM-dd'
    con.rightoperator = this.datePipe.transform(con.rightoperator, 'yyyy-MM-dd');
  }
  changeTime(con) {
    // Format selected time to 12-hour format with AM/PM
    con.rightoperator = this.formatTime(con.rightoperator);
  }
  formatTime(selectedTime: Date): string {
    // Format selected time to 12-hour format with AM/PM
    const formattedTime = new Date(selectedTime);
    const options: Intl.DateTimeFormatOptions = { hour: 'numeric', minute: 'numeric', hour12: true };
    const timeString = formattedTime.toLocaleTimeString('en-US', options);
    return timeString;
  }

  RemoveInputfieldCondition() {
    // remove condition from saved condition list if user is trying to remove a condition
    if (!this.inputfieldConditionType.title_resolver || this.inputfieldConditionType.title_resolver == '') {
      this.toast.error('Please select any condition');
      return;
    }
    let statusCondition = this.inputfieldConditionType.SavedConditions.filter(res => res._id === this.inputfieldConditionType.title_resolver)?.[0];
    if (statusCondition) {
      // remove condition from saved condition list
      this.remmiConfirm
        .delete({ title: 'Delete Saved Condition?', message: 'This saved condition will be permanently deleted.', subject: statusCondition?.title })
        .subscribe(isConfirmed => isConfirmed && this.RemoveInputfieldSavedConditions(statusCondition?._id));
    }
  }

  SaveorLoadInputfieldCondition(condition_array) {
    // if user is loading a saved condition
    if (this.inputfieldConditionType.isLoadSelected) {
      if (!this.inputfieldConditionType.title_resolver || this.inputfieldConditionType.title_resolver == '') {
        this.toast.error('Please select any condition');
        return;
      }
      let statusCondition = this.inputfieldConditionType.SavedConditions.filter(res => res._id === this.inputfieldConditionType.title_resolver)?.[0];
      if (statusCondition) {
        this.condition_input = statusCondition?.con_list;
        this.flow_data.inputfield = this.condition_input;
      }
    }
    // if user is saving a new condition
    else if (this.inputfieldConditionType.isLoadSelected === false) {
      if (!this.inputfieldConditionType.title_resolver || this.inputfieldConditionType.title_resolver == '') {
        this.toast.error('Must save with name');
        return;
      }
      this.SaveInputfieldConditionsByTriggerId(
        this.flowStackCall?.[0]?._id,
        this.inputfieldConditionType.title_resolver,
        [condition_array],
        this.flowStackCall?.[0]?.module
      );
    }
  }

  LoadSavedInputfieldConditions() {
    // Load saved workflow input field conditions by its trigger ID
    this._workflowService.GetWorkflowSavedConditons(this.flowStackCall?.[0]?._id, this.flowStackCall?.[0]?.module).subscribe({
      next: response => {
        try {
          const { data, status } = response;
          if (status) {
            this.ResetFormFields();
            this.inputfieldConditionType.SavedConditions = data;
          }
        } catch (error) {
          this.inputfieldConditionType.SavedConditions = [];
        }
      },
      error: _ => {
        this.inputfieldConditionType.SavedConditions = [];
        this.toast.error('Something went wrong');
      },
    });
  }

  SaveInputfieldConditionsByTriggerId(id, saveAsName = '', conditionArray = [], module = null) {
    // Save a new workflow input field condition by its trigger ID
    this._workflowService.SaveModuleInputFieldConditions(id, conditionArray, saveAsName, module).subscribe({
      next: response => {
        try {
          const { status } = response;
          if (status) {
            this.toast.success('Condition saved successfully');
            this.LoadSavedInputfieldConditions();
          }
        } catch (error) {
          this.toast.error('Something went wrong');
        }
      },
      error: _ => {
        this.toast.error('Something went wrong');
      },
    });
  }

  RemoveInputfieldSavedConditions(conditionId: string = '') {
    // Remove a saved workflow input field condition by its ID
    this._workflowService.RemoveSavedWorkflowInputfieldCondition(conditionId).subscribe({
      next: response => {
        try {
          const { status } = response;
          if (status) {
            this.toast.success('Condition removed successfully');
            this.LoadSavedInputfieldConditions();
          }
        } catch (error) {
          this.toast.error('Something went wrong');
        }
      },
      error: _ => {
        this.toast.error('Something went wrong');
      },
    });
  }

  onReady(editor, _api) {
    // Hide the powered by CKEditor element when the editor is in focus
    editor.editing.view.document.on('focus', () => {
      let poweredByCKeditorElement = document.querySelector('.ck-body-wrapper');
      if (poweredByCKeditorElement) {
        poweredByCKeditorElement.remove();
      }
    });

    // Move the toolbar above the text area
    editor.ui.getEditableElement().parentElement.insertBefore(editor.ui.view.toolbar.element, editor.ui.getEditableElement());

    // Set the upload adapter for the CKEditor image upload
    // editor.plugins.get('FileRepository').createUploadAdapter = function (loader) {
    //   return new UploadAdapter(loader, api);
    // };
  }
  //#endregion

  onChangeStartStatus(event, value) {
    // Update the start operation time value based on the checkbox status
    const { checked } = event;
    this.flow_data.startoperationtime[`${value}`] = checked;
  }

  clearTitleResolver() {
    // Clear the title_resolver if isLoadSelected is false
    if (!this.inputfieldConditionType.isLoadSelected) {
      this.inputfieldConditionType.title_resolver = '';
    }
  }

  updateFilterProcess(event) {
    // update the filter of the process in the current flowStackCall array
    if (event._id == this.flow_data._id) {
      this.flow_data.filter = event.filter;
    }
    if (this.flowStackCall.length > 0) {
      for (let i = 0; i < this.flowStackCall.length; i++) {
        // if the event id matches the id of the process in the flowStackCall array, update the filter
        if (this.flowStackCall[i]._id == event._id) {
          this.flowStackCall[i].filter = event.filter;
        }
      }
    }
  }

  onTimeInputChange(event: any, type: any) {
    const input = event.target.value.trim();
    const timeRegex = /^(\d{1,2})(?::?(\d{2}))?\s*([APap][Mm])?$/;

    const match = input.match(timeRegex);

    if (!match) {
      this.flow_data.advanced_scheduling[type].time = ''; //'Invalid time format';
      return;
    }

    let [_, hourStr, minuteStr, amPm] = match;

    let hour = parseInt(hourStr, 10);
    let minutes = minuteStr ? parseInt(minuteStr, 10) : 0;

    if (hour > 24 || minutes > 59) {
      this.flow_data.advanced_scheduling[type].time = ''; //'Invalid time';
      return;
    }

    // Convert PM times in 24-hour format to AM
    if (amPm && amPm.toUpperCase() === 'PM' && hour < 12) {
      hour += 12;
    }

    if (!amPm) {
      if (hour >= 12) {
        if (hour >= 24) {
          amPm = ''; // Treat as 24-hour format
        } else {
          hour -= 12;
          amPm = 'PM';
        }
      } else {
        amPm = 'AM';
      }
    } else {
      amPm = amPm.toUpperCase();
    }

    if (hour === 0 && amPm === 'AM') {
      hour = 12;
    }

    if (hour > 12 && amPm === 'AM') {
      // Handle cases like "15AM" by assuming it's a 24-hour format
      amPm = 'PM';
      hour -= 12;
    }

    if (hour > 12 && amPm === 'PM') {
      // Handle cases like "18:00 AM" by assuming it's a 12-hour format
      hour -= 12;
    }
    let time = `${hour.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')} ${amPm}`;
    this.flow_data.advanced_scheduling[type].time = time;
  }

  contact_fields: any[] = [];
  project_fields: any[] = [];
  contract_fields: any[] = [];
  lead_fields: any[] = [];
  property_fields: any[] = [];
  project_unit_fields: any[] = [];
  property_data_fields: any[] = [];
  task_fields: any[] = [];
  EOI_fields: any[] = [];
  OFI_fields: any[] = [];

  getAllModuleFields() {
    // Get all fields for all modules
    for (let module of this._workflowService.module_array) {
      let data = {
        module: module.module_value,
        office_id: this.api.getOfficeId(),
        user_id: this.api.getUserId(),
      };
      this._entityManagerService.getCollectionField(data).subscribe({
        next: response => {
          if (response && response.data && response.data.fields) {
            this.all_module_fields[module.module_value] = response.data.fields;
          }
          switch (module.module_value) {
            case 'projects':
              this.project_fields = response?.data?.fields;
              break;
            case 'contacts':
              this.contact_fields = response?.data?.fields;
              break;
            case 'contract':
              this.contract_fields = response?.data?.fields;
              break;
            case 'lead_management':
              this.lead_fields = response?.data?.fields;
              break;
            case 'properties':
              this.property_fields = response?.data?.fields;
              break;
            case 'project_units':
              this.project_unit_fields = response?.data?.fields;
              break;
            case 'properties_data':
              this.property_data_fields = response?.data?.fields;
              break;
            case 'tasks':
              this.task_fields = response?.data?.fields;
              break;
            case 'EOI':
              this.EOI_fields = response?.data?.fields;
              break;
            case 'ofi':
              this.OFI_fields = response?.data?.fields;
              break;
            default:
              break;
          }
        },
      });
    }
  }
  onChangeTriggerCanStart(event: InputSwitchOnChangeEvent) {
    // Update the canStart property of the trigger in the flowStackCall array
    this.flow_data.canStart = event.checked;
    this.flowStackCall[0].canStart = event.checked;
  }
  bindValue() {
    // Bind the title and description of the trigger to the first element of the flowStackCall array
    this.flowStackCall[0].tigger_title = this.flow_data.tigger_title;
    this.flowStackCall[0].tigger_desc = this.flow_data.tigger_desc;
  }
}
